import Enum from '/@/modules/core/app/helpers/Enum';
import { EstateType } from '/@/modules/estate/enums/EstateType';

export abstract class GuidanceStepEnum extends Enum {
  static getClearEstatePrefix(): string {
    return 'ce_';
  }

  static getClearVaultPrefix(): string {
    return 'cv_';
  }

  static getClearWillPrefix(): string {
    return 'cw_';
  }

  static getKeysByType(estateType: string): Record<string, unknown> {
    return Object.fromEntries(
      Object.entries(this.getKeyValues()).filter(([key]: [string, unknown]) =>
        key.toLowerCase().startsWith(this.getPrefixFromType(estateType))
      )
    );
  }

  static getPrefixFromType(estateType: string): string {
    switch (estateType) {
      case EstateType.CLEAR_ESTATE.key:
        return this.getClearEstatePrefix();
      case EstateType.CLEAR_VAULT.key:
        return this.getClearVaultPrefix();
      case EstateType.CLEAR_WILL.key:
        return this.getClearWillPrefix();
      default:
        throw new Error(`No estate type matched for: ${estateType}`);
    }
  }
}
